import { useId, useState, useRef } from "react";
import { useClickAway } from "react-use";
import IconInfo from "app/icons/IconInfo";

export default function GameMenu({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const id = useId();
  const [isOpen, setIsOpen] = useState(false);
  const menuId = `menu-${id}`;
  const buttonId = `menubutton-${id}`;

  useClickAway(ref, () => {
    setIsOpen(false);
  });

  return (
    <div ref={ref} className="relative inline-flex h-fit w-fit">
      <button
        id={buttonId}
        aria-haspopup="true"
        aria-expanded={isOpen ? "true" : "false"}
        aria-controls={menuId}
        className="cursor-pointer"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <IconInfo />
      </button>

      {isOpen && (
        <div
          className="absolute end-0 start-auto top-full z-50 my-1 grid w-47.5 grid-cols-1 items-center justify-center border border-t-black border-gray-500 bg-white text-black p-1.5 text-center text-sm font-medium uppercase shadow-modal *:h-10"
          id={menuId}
          role="menu"
          tabIndex={-1}
          aria-labelledby={buttonId}
        >
          {children}
        </div>
      )}
    </div>
  );
}